import './AnalyticsChange.css';

export type ChangeDirection = 'up' | 'down' | 'flat' | 'unavailable';
export function changeDirection(current: number | null, previous: number | null): ChangeDirection {
  if (current === null || previous === null || !Number.isFinite(current) || !Number.isFinite(previous)) return 'unavailable';
  return current === previous ? 'flat' : current > previous ? 'up' : 'down';
}

export default function AnalyticsChange({ direction, label, preference = 'higher' }: {
  direction: ChangeDirection;
  label: string;
  preference?: 'higher' | 'lower' | 'neutral';
}) {
  const tone = direction === 'flat' || direction === 'unavailable' ? 'neutral'
    : preference === 'neutral' ? direction === 'up' ? 'increase' : 'decrease'
      : (direction === 'up') === (preference === 'higher') ? 'positive' : 'negative';
  const description = direction === 'up' ? 'Increased' : direction === 'down' ? 'Decreased' : direction === 'flat' ? 'Unchanged' : 'Comparison unavailable';
  return <span className={`analytics-change analytics-change--${tone}`}>
    <span aria-hidden="true">{direction === 'up' ? '↑' : direction === 'down' ? '↓' : '—'}</span>
    <span className="analytics-change-sr">{description}: </span>{label}
  </span>;
}
